import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmWarningIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmWarningIcon = ({ className, ...props }: EmWarningIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_329_39422)">
      <path
        d="M9.751 0.841975L0.24726 19.8495C-0.107303 20.5842 0.199741 21.4669 0.932626 21.8215C1.13001 21.9165 1.34385 21.9677 1.56316 21.9695H20.5706C21.3858 21.9622 22.0419 21.2951 22.0346 20.48C22.0328 20.2625 21.9816 20.0468 21.8865 19.8495L12.3828 0.841975C12.0155 0.114573 11.1272 -0.176022 10.4016 0.191334C10.1202 0.33389 9.89356 0.562346 9.751 0.841975Z"
        fill="#F2A600"
      />
      <path
        d="M9.09283 2.17616L0.173937 19.9774C-0.160522 20.6664 0.128245 21.4962 0.817267 21.8306C0.998203 21.9184 1.19742 21.9659 1.39846 21.9695H19.218C19.9801 21.9622 20.5924 21.339 20.5851 20.5769C20.5832 20.3685 20.5339 20.1638 20.4425 19.9774L11.5419 2.17616C11.2147 1.49993 10.4033 1.21665 9.72703 1.54197C9.44922 1.67721 9.22625 1.90018 9.09283 2.17616Z"
        fill="#FFCC32"
      />
      <g opacity="0.2">
        <path
          d="M11.0667 5.52078C11.9074 5.52078 12.5836 6.19701 12.5288 6.9829L11.9074 15.7556C11.8379 16.2198 11.4066 16.5415 10.9424 16.472C10.5714 16.4172 10.2808 16.1266 10.226 15.7556L9.60456 6.9829C9.54973 6.19701 10.226 5.52078 11.0667 5.52078Z"
          fill="#424242"
        />
        <path
          d="M11.0669 17.2177C11.6719 17.2177 12.1635 17.7093 12.1635 18.3142C12.1635 18.9192 11.6719 19.4108 11.0669 19.4108C10.462 19.4108 9.97034 18.9192 9.97034 18.3142C9.97034 17.7093 10.462 17.2177 11.0669 17.2177Z"
          fill="#424242"
        />
      </g>
      <path
        d="M11.0667 5.52078C11.9074 5.52078 12.5836 6.19701 12.5288 6.9829L11.9074 15.7556C11.8379 16.2198 11.4066 16.5415 10.9424 16.472C10.5714 16.4172 10.2808 16.1266 10.226 15.7556L9.60456 6.9829C9.54973 6.19701 10.226 5.52078 11.0667 5.52078Z"
        fill="url(#paint0_linear_329_39422)"
      />
      <path
        d="M11.0669 19.4109C11.6725 19.4109 12.1635 18.9199 12.1635 18.3143C12.1635 17.7087 11.6725 17.2177 11.0669 17.2177C10.4613 17.2177 9.97034 17.7087 9.97034 18.3143C9.97034 18.9199 10.4613 19.4109 11.0669 19.4109Z"
        fill="url(#paint1_linear_329_39422)"
      />
      <path
        d="M9.09312 3.51034C8.8738 3.78448 5.18196 11.0037 5.18196 11.0037C5.18196 11.0037 4.85299 11.552 5.3099 11.8627C5.73026 12.1551 6.11406 11.8078 6.27855 11.5337C6.44304 11.2595 9.78762 4.78968 9.91556 4.47899C10.0252 4.13722 9.94845 3.76438 9.71452 3.49206C9.47692 3.27274 9.23933 3.30929 9.09312 3.51034Z"
        fill="#FFF170"
      />
      <path
        d="M5.0355 13.6739C5.36859 13.6739 5.63862 13.4038 5.63862 13.0707C5.63862 12.7376 5.36859 12.4676 5.0355 12.4676C4.7024 12.4676 4.43237 12.7376 4.43237 13.0707C4.43237 13.4038 4.7024 13.6739 5.0355 13.6739Z"
        fill="#FFF170"
      />
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_329_39422"
        x1="11.0667"
        x2="11.0667"
        y1="5.20093"
        y2="19.5826"
      >
        <stop stopColor="#424242" />
        <stop
          offset="1"
          stopColor="#212121"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_329_39422"
        x1="11.0669"
        x2="11.0669"
        y1="5.92836"
        y2="20.3101"
      >
        <stop stopColor="#424242" />
        <stop
          offset="1"
          stopColor="#212121"
        />
      </linearGradient>
      <clipPath id="clip0_329_39422">
        <rect
          fill="white"
          height="22"
          width="22"
        />
      </clipPath>
    </defs>
  </svg>
);

export default EmWarningIcon;
